import APIService from 'services/APIService'

const api = APIService()

export const listAssets = bpId =>
  api.get(`/building-passport/${bpId}/assets`)

export const detectAssets = bpId =>
  api.post(`/building-passport/${bpId}/assets/detect`)

export const createAsset = (bpId, payload) =>
  api.post(`/building-passport/${bpId}/assets`, payload)

export const updateAsset = (bpId, assetId, payload) =>
  api.patch(`/building-passport/${bpId}/assets/${assetId}`, payload)

export const deleteAsset = (bpId, assetId) =>
  api.delete(`/building-passport/${bpId}/assets/${assetId}`)
